import { AlertCircle, Check } from "lucide-react";
import React from "react";
import "../assets/css/multipleFormModal.css";

const MultipleFormModal = ({ modalStatus }) => {
  return (
    <div
      className="multiple-form_modal"
      style={{
        backgroundColor: `${modalStatus.isSuccessfull ? "green" : "red"}`,
      }}
    >
      <div
        className="icon-container"
        // style={{
        //   backgroundColor: `${modalStatus.isSuccessfull ? "green" : "red"}`,
        // }}
      >
        {modalStatus.isSuccessfull ? <Check /> : <AlertCircle />}
      </div>
      <div className="modal-message">{modalStatus.message}</div>
    </div>
  );
};

export default MultipleFormModal;
